import React, { useEffect, useState } from "react";
import { getAIOverview } from "../services/api";

export const aiCache = {};

function AIOverview({ selectedDate }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const key = selectedDate || "dashboard";

      if (aiCache[key]) {
        setData(aiCache[key]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const res = await getAIOverview(selectedDate);
        aiCache[key] = res;
        setData(res);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [selectedDate]);

  return (
    <div className="ai-overview-card">
      <div className="ai-top-line">
        <span className="ai-badge">Live AI Coach</span>
        <span className="ai-badge subtle">Updates as you journal</span>
      </div>

      <h3>{selectedDate ? "Daily AI Overview" : "Dashboard AI Overview"}</h3>

      {loading ? (
        <p className="ai-message">Thinking...</p>
      ) : !data ? (
        <p className="ai-message">Failed to load AI overview.</p>
      ) : (
        <>
          <div className="score-block">
            <div className="score-circle">
              <span>{data.score || 0}</span>
            </div>
            <div>
              <p className="score-title">{data.locked ? "Pro Feature" : "Trade Score"}</p>
              <p className="score-note">
                {data.locked
                  ? "Upgrade to Pro to unlock AI overviews and deeper trade review."
                  : data.used_screenshots
                  ? "More accurate score — screenshots provided."
                  : "Add screenshots for better scoring accuracy."}
              </p>
            </div>
          </div>

          <p className="ai-message">{data.summary}</p>

          {!data.locked && (
            <div className="ai-detail-box">
              <p><strong>Strength:</strong> {data.strengths}</p>
              <p><strong>Weakness:</strong> {data.weakness}</p>
              <p><strong>Next Step:</strong> {data.next_step}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AIOverview;